import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatusAlertProviders } from './status-alert.provider';

@Component({
  selector: 'y42-status-alert',
  template: `<router-outlet></router-outlet>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: StatusAlertProviders(),
})
export class StatusAlertComponent {}
